module.exports = __webpack_public_path__ + "img/电梯动画7.b23f4f3d.png";